import { useEffect, useState } from 'react';
import configuration from '../../envConfig';

interface ConnectionInfo {
  isOnline: boolean;
  connectionType?: string;
}

function useConnectionStatus(): ConnectionInfo {
  const [connectionStatus, setConnectionStatus] = useState<ConnectionInfo>({
    isOnline: navigator.onLine,
  });

  useEffect(() => {
    if (configuration.isCordova) {
      const onDeviceReady = () => {
        if (navigator.connection) {
          const connectionType = navigator.connection?.type;
          const isConnected = connectionType !== 'none';
          setConnectionStatus({
            isOnline: isConnected,
            connectionType: connectionType,
          });
        }

        document.addEventListener('online', () => {
          setConnectionStatus((prev) => ({ ...prev, isOnline: true }));
        });

        document.addEventListener('offline', () => {
          setConnectionStatus((prev) => ({ ...prev, isOnline: false }));
        });
      };

      document.addEventListener('deviceready', onDeviceReady);

      return () => {
        document.removeEventListener('deviceready', onDeviceReady);
      };
    } else {
      const handleOnline = () => setConnectionStatus((prev) => ({ ...prev, isOnline: true }));
      const handleOffline = () => setConnectionStatus((prev) => ({ ...prev, isOnline: false }));

      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);

      return () => {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
      };
    }
  }, []);

  return connectionStatus;
}

export default useConnectionStatus;
